globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import * as React from 'react';
import { useMemo, useCallback } from 'react';
import { Avatar } from 'flowbite-react';
import { useModal } from '@restworld/utils-common';
import { Title, RatingChart, Paragraph, MobileModal } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ListTertiary = function ListTertiary(_ref) {
  var _ref$jobPerformanceIt = _ref.jobPerformanceItemList,
      jobPerformanceItemList = _ref$jobPerformanceIt === void 0 ? [] : _ref$jobPerformanceIt,
      careerPossibilityDescription = _ref.careerPossibilityDescription;

  var _usePerformanceList = usePerformanceList({
    jobPerformanceItemList: jobPerformanceItemList,
    showModal: Boolean(careerPossibilityDescription)
  }),
      listElement = _usePerformanceList.listElement,
      show = _usePerformanceList.show,
      close = _usePerformanceList.close;

  var modal = useMemo(function () {
    return /*#__PURE__*/_jsx(MobileModal, {
      show: show,
      close: close,
      children: /*#__PURE__*/_jsxs(ModalContent, {
        children: [/*#__PURE__*/_jsx(Title, {
          isCenter: true,
          fontSize: "large",
          content: "Possibilit\xE0 di carriera",
          icon: "ArrowTrendingUpIcon"
        }), /*#__PURE__*/_jsx(Paragraph, {
          content: careerPossibilityDescription
        })]
      })
    });
  }, [careerPossibilityDescription, close, show]);
  return /*#__PURE__*/_jsxs(ListWrapper, {
    children: [listElement, modal]
  });
};
export default ListTertiary; // --> parent > styled components

var commonStyle = "flex flex-col gap-4";

var ModalContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listtertiary__ModalContent",
  componentId: "sc-1tpfsgi-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingBottom": "0.75rem"
});

var ListWrapper = /*#__PURE__*/_styled.ul.withConfig({
  displayName: "listtertiary__ListWrapper",
  componentId: "sc-1tpfsgi-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var ItemWrapper = /*#__PURE__*/_styled.li.withConfig({
  displayName: "listtertiary__ItemWrapper",
  componentId: "sc-1tpfsgi-2"
})({});

var ImageIconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "listtertiary__ImageIconWrapper",
  componentId: "sc-1tpfsgi-3"
})({});

var ImageTitleWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listtertiary__ImageTitleWrapper",
  componentId: "sc-1tpfsgi-4"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem"
});

var ItemEventWrapper = /*#__PURE__*/_styled.a.withConfig({
  displayName: "listtertiary__ItemEventWrapper",
  componentId: "sc-1tpfsgi-5"
})(["", " ", ""], {
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1rem"
}, function (_ref2) {
  var hasChild = _ref2.hasChild;
  return hasChild ? {
    "pointerEvents": "auto"
  } : {
    "pointerEvents": "none"
  };
});

var ItemContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listtertiary__ItemContent",
  componentId: "sc-1tpfsgi-6"
})({
  "flexShrink": "10"
});

var AvatarStyled = /*#__PURE__*/_styled(Avatar).withConfig({
  displayName: "listtertiary__AvatarStyled",
  componentId: "sc-1tpfsgi-7"
})([""]); // --> types


var usePerformanceList = function usePerformanceList(_ref3) {
  var jobPerformanceItemList = _ref3.jobPerformanceItemList,
      showModal = _ref3.showModal;

  var _useModal = useModal(),
      show = _useModal.show,
      close = _useModal.close,
      open = _useModal.open;

  var clickHandler = useCallback(function (e) {
    e.preventDefault();
    open();
  }, [open]);
  var listElement = useMemo(function () {
    return jobPerformanceItemList.map(function (_ref4) {
      var title = _ref4.title,
          subTitle = _ref4.subTitle,
          hasChild = _ref4.hasChild,
          key = _ref4.key,
          rating = _ref4.rating,
          icon = _ref4.icon;
      var isModalShow = hasChild && showModal;
      var iconEl = null;
      if (rating) iconEl = /*#__PURE__*/_jsx(RatingChart, {
        rating: rating,
        icon: icon
      });
      if (key === 'recruiter-profile') iconEl = /*#__PURE__*/_jsx(AvatarStyled, {
        rounded: true,
        img: icon,
        size: "lg"
      });
      return /*#__PURE__*/_jsx(ItemWrapper, {
        children: /*#__PURE__*/_jsx(ItemEventWrapper, {
          href: "#!",
          hasChild: isModalShow,
          onClick: clickHandler,
          children: /*#__PURE__*/_jsxs(ImageTitleWrapper, {
            children: [iconEl ? /*#__PURE__*/_jsx(ImageIconWrapper, {
              children: iconEl
            }) : null, /*#__PURE__*/_jsxs(ItemContent, {
              children: [/*#__PURE__*/_jsx(Title, {
                fontSize: "base",
                content: title
              }), /*#__PURE__*/_jsx(Title, {
                fontSize: "base",
                textColor: "gray",
                content: subTitle || '',
                fontWeight: "normal"
              })]
            })]
          })
        })
      }, key);
    });
  }, [jobPerformanceItemList, showModal, clickHandler]);
  return {
    show: show,
    close: close,
    listElement: listElement
  };
};